export const BEIGE  = "#FFF1E5";
export const BROWN  = "#623107";
export const BLACK  = "#333333";
export const RED    = "#FF0000";

export const ORANGE = {
  light:  "#FFB578",
  normal: "#FA9744",
  shadow: "#BD6635",
  border: "#924C10"
};

export const BLUE = {
  sky:    "#C3ECFB;",
  normal: "#72BDD8",
  shadow: "#4995B0"
};

export const GREEN = {
  normal: "#054419",
  shadow: "#002B00"
}
